import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "modal" ]

  submit() {
    this.modalTarget.classList.add("loading")
  }
}
